import {Component, EventEmitter, Injectable, Input, Output} from '@angular/core';
import 'firebase/firestore';
import {Campus} from '../../model/Campus';
import {Helper} from '../../model/Helper';

export interface UploadCoverPayload {
  campus: Campus;
  file: File;
}

export interface RemoveCoverPayload {
  campus: Campus;
}

@Component({
  selector: 'app-edit-campus-cover',
  templateUrl: 'edit-campus-cover.component.html',
  styleUrls: ['edit-campus-cover.component.css'],
})

@Injectable()
export class EditCampusCoverComponent {
  // View
  @Input() public campus: Campus;
  @Output() public uploadCover = new EventEmitter<UploadCoverPayload>();
  @Output() public removeCover = new EventEmitter<RemoveCoverPayload>();

  public Helper = Helper;

  public async uploadCoverClicked(): Promise<void> {
    const fileButton = document.getElementById('coverFile') as HTMLInputElement;
    this.uploadCover.emit({
      campus: this.campus,
      file: fileButton.files[0],
    });
  }

  public removeCoverClicked(): void {
    this.removeCover.emit({
      campus: this.campus,
    });
  }
}
